import { BorderGridContainer, FullScreenHeader, GridBox, PortableText } from '@ahmdigital/ui';
import { toLower } from 'lodash/fp';
import React from 'react';

type HeaderSectionProps = {
  name: string;
  slogan: string | unknown[];
  summary: unknown[];
};

const HeaderSection = ({ name, slogan, summary }: HeaderSectionProps) => (
  <BorderGridContainer hideBorderTop>
    <GridBox padding="1rem">
      <FullScreenHeader
        title={<PortableText source={slogan} />}
        subtitle={<PortableText source={summary} />}
        scrollToElementText={`The ins and outs of ${toLower(name)}`}
        scrollToNextElement
      />
    </GridBox>
  </BorderGridContainer>
);

export default HeaderSection;
